//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InformationCard from './InformationCard.vue';
export default {
  components: {
    InformationCard,
  },
  data() {
    return {
      informationCards: [
        {
          id: 1,
          title: this.$t('about-us.1.title'),
          description: this.$t('about-us.1.description'),
          backgroundGradient:
            'linear-gradient(90deg, #3F7AF8 0%, #8A53F7 100%)',
        },
        {
          id: 2,
          title: this.$t('about-us.2.title'),
          description: this.$t('about-us.2.description'),
          backgroundGradient:
            'linear-gradient(90deg, #B46BFA 0%, #F06359 100%)',
        },
        {
          id: 3,
          title: this.$t('about-us.3.title'),
          description: this.$t('about-us.3.description'),
          backgroundGradient:
            'linear-gradient(90deg, #F0762B 0%, #E34D98 100%)',
        },
        {
          id: 4,
          title: this.$t('about-us.4.title'),
          description: this.$t('about-us.4.description'),
          backgroundGradient:
            'linear-gradient(90deg, #53B3BE 0%, #3650D3 100%)',
        },
      ],
    };
  },
};
